module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="task-panel">\n    <div class="taskHeader"></div>\n    <div class="taskBody">\n        <div class="recordContainer"></div>\n        <div class="taskTabBar" style="display: none;"></div>\n    </div>\n</div>';

}
return __p
}